import React from 'react';

import { Container } from '@common/components';
import ContactUs from '@components/ContactUs/ContactUs';
import NotFound from '@components/404';
import PortalContainer from '@components/PortalContainer';

const NotFoundPage = props => (
  <PortalContainer is404={true}>
    <NotFound {...props} />
    <Container>
      <ContactUs />
    </Container>
  </PortalContainer>
);

export default NotFoundPage;
